import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import BaseDetails from 'containers/Base/BaseDetails';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { companyActions, companySelectors } from '../';

const CompanyDetails = ({ id, cancel, editable = false }) => {
  const companyDetails = useSelector(
    state => companySelectors.getCompanyDetails(state),
    shallowEqual,
  );
  const loading = useSelector(state => state.ui.loading);
  const dispatch = useDispatch();
  //
  const dispatchFetchCompanyDetails = useCallback(
    id => dispatch(companyActions.fetchGridRowDetails({ id })),
    [dispatch],
  );
  useEffect(() => {
    if (id) {
      dispatchFetchCompanyDetails(id);
    }
    // eslint-disable-next-line no-empty-function
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return (
    <BaseDetails
      header="Company Details"
      editable={editable}
      cancel={cancel}
      details={companyDetails}
      loading={loading}
    />
  );
};
CompanyDetails.propTypes = {
  id: PropTypes.string,
  cancel: PropTypes.func,
  editable: PropTypes.bool,
};
export default CompanyDetails;
